module.exports = __webpack_public_path__ + "static/img/misi.6d7fee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/misi.png
// module id = jzs/
// module chunks = 2